import * as React from 'react';
import '../styles/App.css';

class HeaderContent extends React.Component {
  render() {
    return (
        <div className="HeaderContent"/>
    );
  }
}

export default HeaderContent;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/HeaderContent.tsx